export const useColorTheme = () => {
    const mode = useColorMode({
        emitAuto: true,
        attribute: "theme-mode",
        storageKey: "theme-mode",
        onChanged: (v, handler) => {
            nextTick(() => {
                var element = document.querySelector<HTMLElement>("#theme-btn")
                if (element) {
                    const bounding = useElementBounding(element)
                    const x = bounding.x.value + bounding.width.value / 2
                    const y = bounding.top.value + bounding.height.value / 2
                    const endRadius = Math.hypot(
                        Math.max(x, innerWidth - x),
                        Math.max(y, innerHeight - y),
                    )
                    // @ts-ignore
                    if (document.startViewTransition) {
                        // @ts-ignore
                        const transition = document.startViewTransition(() => {
                            const root = document.documentElement
                            const isDark = v === "dark"
                            if (isDark) {
                                root.setAttribute("theme-mode", "dark")
                            } else {
                                root.removeAttribute("theme-mode")
                            }
                        })
                        transition.ready
                            .then(() => {
                                const clipPath = [
                                    `circle(0px at ${x}px ${y}px)`,
                                    `circle(${endRadius}px at ${x}px ${y}px)`,
                                ]
                                document.documentElement.animate(
                                    {
                                        clipPath: v === "dark" ? clipPath : clipPath.reverse(),
                                    },
                                    {
                                        duration: 500,
                                        easing: "ease-in-out",
                                        pseudoElement:
                                            v === "dark"
                                                ? "::view-transition-new(root)"
                                                : "::view-transition-old(root)",
                                    },
                                )
                            })
                            .catch(() => {})
                            .finally(() => {
                                if (state.value != "auto") {
                                    state.value = v
                                }
                            })
                    }
                } else {
                    handler(v)
                }
            })
        },
    })

    const { state, next: nextTheme } = useCycleList<typeof mode.value>(["dark", "light", "auto"], {
        initialValue: mode,
    })

    watchEffect(() => (mode.value = state.value as any))

    return reactive({
        state: state,
        nextTheme: () => nextTheme(),
        mode,
    })
}
